import { createStore, applyMiddleware, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import {
    createStateSyncMiddleware,
    withReduxStateSync,
} from "redux-state-sync";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import rootReducer from "../reducers/index";
import signalRMiddleware from "./signalRMiddleWare";
import {
    I18n,
    Translate,
    Localize,
    setTranslationsGetter,
    setLocaleGetter,
    forceComponentsUpdate,
} from "react-i18nify";
import * as actionTypes from "../actionTypes";
export { I18n, Translate, Localize, forceComponentsUpdate };

const persistConfig = {
    key: "OneTsigane",
    storage,
    whitelist: ["auth", "i18n"],
};

const syncConfig = {
    blacklist: ["persist/PERSIST", "persist/REHYDRATE",
        actionTypes.CURRENTENTITY,
        actionTypes.TREEMENUWIDTH,
        actionTypes.SETTINGSMENUWIDTH,
        actionTypes.UPDATEENTITYTREE,
        actionTypes.UPDATESPECIFICNODE,
        actionTypes.QUICKSEARCHFILTER,
        actionTypes.SEARCHCATEGORIES_IMMEDIATE,
        actionTypes.MAXRESULTCOUNT,
        actionTypes.TREEVIEWNODEEXPAND,
        actionTypes.DIFFERENTENTITYSELECTED,
        actionTypes.UPDATEHIGHLIGHTEDROWS,
        actionTypes.MAPPREF,
        actionTypes.INITIALIZEPREFS,
        actionTypes.QUICKSEARCH,
        actionTypes.ISFETCHING,
        actionTypes.NEXTFOLLOWEDUSERROUTE,
        actionTypes.NEWNOTIFCOUNT,
        actionTypes.MENUBOOKMARKED,
        actionTypes.MENUUNBOOKMARKED,
        actionTypes.SEARCHTEXTCHANGED,
        actionTypes.HIDENEWFEATURESPOPUP,
        actionTypes.UPDATESHEETNAME,
        actionTypes.UPDATEDATAVALIDATIONPROGRESS,
        actionTypes.UPDATEENTITIESLIST,
        actionTypes.REFRESH_GLOBALSEARCHBAR,
        actionTypes.UPDATEBRANCHESANDCOUNTRIES,
        actionTypes.REFRESHRECYCLEBINGRID,
        actionTypes.SHOW_ADVANCED_SEARCH_CRITERIAS,
        actionTypes.UPDATE_ENTITIES_RESULTS,
        actionTypes.UPDATE_DOCUMENTS_RESULTS,
        actionTypes.UPDATE_STATIONS_RESULTS,
        actionTypes.UPDATE_ZONES_RESULTS,
        actionTypes.UPDATE_SAMPLINGS_RESULTS,
        actionTypes.CLEAR_SEARCH_RESULTS,
        actionTypes.FILTER_CRITERIAS_UPDATED,
        actionTypes.UPDATE_ENTITY_STATUSES,
    ],
    channel: "oneTsigane_state_sync",
};

const middlewares = [
    thunk,
    createStateSyncMiddleware(syncConfig),
    signalRMiddleware,
];

/** Adds persistence to the store, and cache the state in the local storate of the user's browser. DOC*/
const persistedReducer = persistReducer(
    persistConfig,
    withReduxStateSync(rootReducer)
);

export const store = createStore(
    persistedReducer,
    compose(
        applyMiddleware(...middlewares),
        window.__REDUX_DEVTOOLS_EXTENSION__
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : f => f
    )
);


// i18n
function syncTranslationWithStore(store) {
    setTranslationsGetter(() => store.getState().i18n.translations || {});
    setLocaleGetter(() => store.getState().i18n.locale || '');
}
//
syncTranslationWithStore(store);

export const persistor = persistStore(store);
